$('.chip.co2-label').on('click', function(event) {
  const sectionFeatures = $('.section--features.collection');
  if (sectionFeatures.length > 0) {
    sectionFeatures.each(index => {
      const element = sectionFeatures[index];

      (element.id != 'features-footprint') ? 
        element.classList.add('d-none') : 
        element.classList.remove('d-none');
    });

    const scrollValue = $('#features-footprint').offset().top;
    const animationTimeMilliseconds = 800;

    // trigger scroll animation only if chip url setting is empty
    if ($(this).attr('href') == '#') { 
      event.preventDefault();
      $('html, body').animate(
        { scrollTop: scrollValue }, 
        animationTimeMilliseconds
      );
    }
  }
});